import React, { Component } from 'react'
import { withStyles } from '@material-ui/styles'
import {
    TextField,
    Button,
    Grid,
    CircularProgress
} from '@material-ui/core'
import DropZone from './../components/DropZone'
import {
    CustomSnackBar,
    BaseEditor
} from './../components'
import axios from './../plugins/axios'

const styles = theme => ({
    marginBottom: {
        margin: '0 0 20px 0'
    }
})
class PostForm extends Component {

    static defaultProps = {
        title: '',
        cover: '',
        body: ''
    }

    constructor(props) {
        super(props)

        const {
            title,
            cover,
            body
        } = props

        this.state = {
            fetching: false,
            disabled: false,
            isSnackOpen: false,
            errors: {},
            title,
            cover,
            body
        }
    }

    handleChange = name => e => {
        this.setState({
            [name]: e.target.value
        })
    }

    reset = () => {
        this.setState({
            errors: {},
            title: '',
            cover: '',
            body: ''
        })
    }

    storeOrUpdate = async e => {
        e.preventDefault()
        this.setState({
            disabled: true,
            errors: {}
        })

        const {
            path,
            method
        } = this.props

        const {
            title,
            cover,
            body
        } = this.state

        try {
            await axios[method](path, {
                title,
                cover,
                body
            })

            this.setState({
                isSnackOpen: true
            })

            if (method === 'post') {
                this.reset()
            }

            this.setState({
                disabled: false
            })
        } catch (err) {
            if (err.response.status === 422) {
                const { errors } = err.response.data
                this.setState({ errors })
            }
        }
    }

    snackClose = () => {
        this.setState({
            isSnackOpen: false
        })
    }

    editorChange = name => e => {
        this.setState({
            [name]: e.target.getContent()
        })
    }

    onChange = (path = '') => {
        this.setState({
            cover: path
        })
    }

    render() {
        const {
            title,
            cover,
            body,
            isSnackOpen,
            errors,
            disabled
        } = this.state

        const { marginBottom } = this.props.classes

        const { message } = this.props
        return (
            <div>

                <form
                    onSubmit={this.storeOrUpdate}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <TextField
                                error={!!errors.title}
                                helperText={errors.title}
                                label="Гарчиг"
                                value={title}
                                onChange={this.handleChange('title')}
                                variant="outlined"
                                margin="normal"
                                fullWidth
                            />
                            <div className={marginBottom}>
                                <DropZone
                                    uploadPath="img/upload"
                                    onChange={this.onChange}
                                    file={cover}
                                    error={!!errors.cover}
                                />
                            </div>
                            <div className={marginBottom}>
                                <BaseEditor
                                    value={body}
                                    onChange={this.editorChange('body')}
                                />
                            </div>
                        </Grid>
                    </Grid>
                    <Button
                        color="primary"
                        variant="contained"
                        type="submit"
                        disabled={disabled}
                    >
                        {
                            disabled ? <CircularProgress size={25} color="primary" /> : "Хадгалах"
                        }
                    </Button>
                    <CustomSnackBar
                        message={message}
                        open={isSnackOpen}
                        snackClose={this.snackClose}
                    />
                </form>
            </div >
        )
    }
}

export default withStyles(styles)(PostForm)
